// extracted by mini-css-extract-plugin
export default {"container":"ToTop_container__deTWL","arrow":"ToTop_arrow__LbR7q","top":"ToTop_top__LVg5R"};